import { Link } from 'react-router-dom';
import { newsItems } from '@/mocks/news';
import { workItems } from '@/mocks/works';
import { cultureItems } from '@/mocks/culture';

const entries = [
  {
    to: '/category/news',
    icon: 'ri-newspaper-line',
    title: '动漫资讯',
    en: 'News',
    desc: '新番定档、制作动态、展会活动与产业观察，每日更新。',
    count: `${newsItems.length} 篇资讯`,
  },
  {
    to: '/category/works',
    icon: 'ri-book-open-line',
    title: '动漫作品',
    en: 'Works',
    desc: '动画与漫画作品档案，含类型、地区、年份与基本资料。',
    count: `${workItems.length} 部作品`,
  },
  {
    to: '/category/culture',
    icon: 'ri-quill-pen-line',
    title: '文化分享',
    en: 'Culture',
    desc: '从美学、分镜到社群生态，深度解读二次元文化脉络。',
    count: `${cultureItems.length} 个专题`,
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {entries.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group flex items-start gap-4 p-5 md:p-6 rounded-lg border border-background-200/80 bg-background-100/50 hover:bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="shrink-0 w-12 h-12 rounded-lg bg-primary-50 text-primary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-semibold text-foreground-950">{entry.title}</span>
                  <span className="text-[10px] tracking-[0.2em] uppercase text-secondary-400 font-label">
                    {entry.en}
                  </span>
                </span>
                <span className="mt-1.5 block text-xs text-secondary-600 leading-5">{entry.desc}</span>
                <span className="mt-3 flex items-center justify-between">
                  <span className="text-[11px] text-secondary-500 font-label">{entry.count}</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-primary-600 group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}